import React, { createContext, useCallback, useContext, useState } from "react";
import { useAuth } from "./AuthProvider";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const { settings } = useAuth();
  const [globelPopupOpen, setGlobelPopupOpen] = useState(false);

  const permission = settings?.staffGroupedPermissions;
  const activeModule = settings?.activeStoreModules;
  const staffBlockedPermissions = settings?.staffBlockedPermissions;
  const storeSettings = settings?.storeSettings || {};
  const customerGroups = settings?.customerGroups || [];
  const stateList = settings?.stateList;

  const hasModulePermission = (moduleName) => {
    return permission?.some((it) => it?.module === moduleName) || false;
  };

  const hasPermission = (moduleName, permissionName) => {
    return (
      permission?.some(
        (item) =>
          item?.module === moduleName &&
          item?.permissions?.includes(permissionName),
      ) || false
    );
  };

  const activeStoreModules = (moduleKey) => {
    return (
      activeModule?.some((it) => it?.moduleKey === moduleKey && it.isValid) ||
      false
    );
  };

  const blockedPermissions = (moduleName) => {
    return !staffBlockedPermissions?.includes(moduleName);
  };

  const viewOption = (moduleName, model) => {
    return storeSettings[moduleName]?.[model];
  };

  const viewOptionSecondLevel = (moduleName, inSideModuleName, model) => {
    return storeSettings[moduleName]?.[inSideModuleName]?.[model];
  };

  return (
    <PermissionContext.Provider
      value={{
        permission,
        stateList,
        hasModulePermission,
        hasPermission,
        activeStoreModules,
        blockedPermissions,
        viewOption,
        storeSettings,
        customerGroups,
        viewOptionSecondLevel,
        globelPopupOpen,
        setGlobelPopupOpen,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);
